const initialState = {
  activeView: "",
}

export const activeView = (state = initialState, event) => {
  switch (event.type) {
    default: {
      return state
    }

    case "UPDATE_ACTIVE_VIEW": {
      return {
        ...state,
        previousView: state.activeView,
        activeView: event.activeView,
      }
    }
  }
}
